package com.example.mystybag.core.model

import androidx.compose.ui.unit.Dp
import dev.icerock.moko.resources.ImageResource
import com.example.mystybag.core.ui.theme.LocalTheme.p20
import com.example.mystybag.core.views.ColorDefines
import com.example.mystybag.core.views.SharedColor
import com.example.mystybag.sharedmodels.SCImage

data class ImageDescription(
    var image    : SCImage?         = null,
    var link     : String?          = null,
    var resource : ImageResource?   = null,
    var icon     : IconDescription? = null,
    var size     : Dp?              = null
)

data class IconDescription(
    var resource    : ImageResource,
    var imageSize   : Dp             = p20,
    var tint        : SharedColor?   = SharedColor(ColorDefines.Primary),
    var background  : SharedColor    = SharedColor(ColorDefines.PrimaryContainer)
)
